<template>
<div>
    <Spinner v-if="loading" >Loading...</Spinner>
    <div v-else>
        <div v-if="type === 'bank.account' || type === 'airtime'">

            <div v-if="view !== 'otp'">
                <!-- =========================== BANK ACCOUNT  ============================== -->
                <div v-if="type === 'bank.account'" class="row debitbank">
                    <div class="selectbank">
                        <p class="title">Select Bank</p>

                        <div class="input-field col s12 cdnumbre">
                            <span class="cdnumber" for="icon_prefix">Bank Name</span>
                            <select id="demoDefaultSelection" v-model="bank_index" @change="selectBank">
                                <option :value="key" :key="key" v-for="(item, key) in chunk_items" :data-imagesrc="item.image_url"> {{ item.option }}</option>
                            </select>
                        </div>


                        <!-- For NIBSS -->
                        <div v-if="show_bank_list" class="input-field col s12 cdnumbre">
                            <span class="cdnumber" for="icon_prefix">Bank Processor</span>
                            <select id="demoDefaultSelection2" v-model="bank_code" @change="selectNibbsBank" style="display:block">
                                <option value="" data-imagesrc="null">&ndash; Select Processor &ndash;</option>
                                <option :value="bank.cbn_code" :key="key" v-for="(bank, key) in banks" data-imagesrc="null">{{ bank.name }}</option>
                            </select>
                        </div>

                        <div class="input-field col s12">
                            <input id="account_name" type="tel" class="validate" maxlength="10" autocomplete="off" minlength="9"   @blur="accountNumberIsFocus=false" @focus="accountNumberIsFocus=true"     @keyup.enter="getOtp" v-model="msisdn" onKeyPress="if(this.value.length == 10) return false;" />
                            <label for="account_name" :class="accountNumberIsFocus || msisdn.length>0 ? 'active' : ''">Account Number</label>
                        </div>
                    </div>

                    <slot name="amount" />

                    <button :disabled=" (show_bank_list && bank_code && msisdn.length === 10) ? false  : ((!show_bank_list && msisdn.length === 10) ? false : true)" @click.prevent="getOtp" class="">Proceed</button>
                </div>
                <!-- =========================== BANK ACCOUNT  ============================== -->


                <!-- =========================== AIRTIME  ============================== -->
                <div v-else-if="type === 'airtime'" class="row payment-form airtime">
                    <div class="selectbank">
                        <form class="col s12">
                            <div class="row">
                                <div class="input-field col s12">
                                    <span class="cdnumber" for="icon_prefix">Phone Number</span>
                                    <input id="phone" v-model="msisdn" :class="msisdn ? 'hasMsisdn' : null" name="phone" type="number" autofocus autocomplete="off" placeholder="0802 981 1111" onKeyPress="if(this.value.length==11) return false;" >
                                </div>
                            </div>
                        </form>
                    </div>

                    <slot name="amount" />

                    <button  :disabled="msisdn.length < 10" @click="getOtp" type="button" class="submit modal-trigger modal-close">Pay Now</button>
                </div>
                <!-- =========================== AIRTIME  ============================== -->
            </div> 

            
            <!-- =========================== OTP ============================== -->
            <div v-else-if="view == 'otp'" class="row verifyrow">
                <p class="enterotp" v-html="headingMessage"></p>

                <div class="verificationform">
                    <input :type="isOTP ? 'number' : 'password'" pattern="[0-9]{1}" style="text-align:center;width: 100% !important;" v-model="trx_otp" :maxlength=" type == 'bank.account' ? (isOTP ? '8' : '25') : '10'" autocomplete="off" minlength="4" autofocus required />
                </div>

                <p class="dnot">Didn't receive an OTP?</p>
                <p class="resend pointer" @click.prevent="resendOtp">Resend OTP</p>

                <button :disabled="trx_otp.length < 4" type="button" class="submit" @click.prevent="submitOtp" @keyup.enter="submitOtp">Submit</button>
            </div>
            <!-- =========================== OTP ============================== -->
        </div>


        <!-- =========================== VOUCHER ============================== -->
        <div v-else-if="type === 'voucher'" id="voucher" class="row payment-form">
            <form class="col s12">
                <div class="vouch">
                    <div class="row">
                        <div class="input-field col s12">
                            <input id="f-voucher" type="number"  @focus="voucherIsFocus=true" @blur="voucherIsFocus=false"  v-model="voucher_pin" @keyup.enter="voucherPay" autofocus required maxlength="30" class="validate" onKeyPress="if(this.value.length==30) return false;" autocomplete="off" >
                            <label for="f-voucher" :class="voucherIsFocus ||  voucher_pin.length > 0 ? 'active' : null">Voucher</label>
                        </div>
                    </div>
                </div>

                <slot name="amount" />

                <button :disabled="voucher_pin.length < 10" @click.prevent="voucherPay" type="button" class="submit modal-trigger modal-close">Pay Now</button>
            </form>
        </div>
        <!-- =========================== VOUCHER ============================== -->


        <!-- ========================== COUNTDOWN, NOINPUT USED FOR USSD VALIDATION/VERIFICATION ====================== -->
        <div v-if="view == 'noinput-countdown' " class="row m-0 ">
            <div v-if="loading">
                <Spinner class="my-2 animate slideInTop" :color="client_info.colors.app" />
                <p>Please wait, processing transaction</p>
            </div>
            <div v-else>

                <p v-if="!loading" class="heading" v-html="headingMessage"></p>

                <div class="col-12 px-0">
                    <p class="my-auto">Verifying Transaction in <strong><span class="text-black">{{ countDownSeconds }} secs </span></strong> ....</p>
                </div>
            </div>
        </div>
        <!-- ========================== COUNTDOWN, NOINPUT USED FOR USSD VALIDATION/VERIFICATION ====================== -->


    </div>
</div>
</template>

<script>
/*
    This Component Handles with 
    Airtime, Voucher, Bank and Wallet Payment
*/

import axios from 'axios';
import Spinner from './includes/Spinner.vue'
// import Paginator from './includes/Paginator.vue'
import {
    EventBus
} from './includes/bus.js';

import {
    nibssBanks
} from './includes/banks.js';
// https://www.sitepoint.com/sort-an-array-of-objects-in-javascript/
// https://www.educative.io/edpresso/how-to-sort-an-array-of-objects-in-javascript

export default {

    name: 'Airtime',
    props: ['data', 'appColor', 'client_info', 'button_color', 'payload'],

    components: {
        Spinner,
        // Paginator
    },

    mounted() {
        
        if (this.type === "bank.account") {
        if (window.$('#demoDefaultSelection'))
            window.$('#demoDefaultSelection').ddslick({
                onSelected: (selectedData) => {
                    // defaultSelectedIndex: 0
                    this.bank_index = selectedData.selectedIndex || 0;
                    this.selectOption(this.bank_index);
                }
            });

        }

        /* if (this.type == "airtime") {
            //Telephone
            var input = document.querySelector("#phone");
            window.intlTelInput(input, {
                // allowDropdown: false,
                // autoHideDialCode: false,
                autoPlaceholder: "on",
                // dropdownContainer: document.body,
                // excludeCountries: ["us"],
                // formatOnDisplay: false,
                // geoIpLookup: function(callback) {
                //   $.get("http://ipinfo.io", function() {}, "jsonp").always(function(resp) {
                //     var countryCode = (resp && resp.country) ? resp.country : "";
                //     callback(countryCode);
                //   });
                // },
                // hiddenInput: "full_number",
                // initialCountry: "auto",
                localizedCountries: {
                    'ng': 'Nigeria'
                },
                // nationalMode: false,
                onlyCountries: ['ng'],
                // placeholderNumberType: "MOBILE",
                preferredCountries: ['ng'],
                separateDialCode: true,
                utilsScript: "build/js/utils.js",
            });
        } */
    },

    created() {
        // console.log(this.data);
        // console.log(this.$store.state.transRef)

        // Show input page if provider is just one
        /* if(this.data.details.details === undefined){
            window.failedFromStartMessage = "No provider is set for this option from the option call.";
            window.failedFromStart = false;
            let raw  = JSON.parse(window.raw);
            raw.message = "No provider is set for this option from the option call.";
            window.raw = JSON.stringify(raw);
            this.$router.push('/v2/mtn/warning');
            return ;
        }else */


        // Listen for the i-got-clicked event and its payload.
        // let vm= this;
        EventBus.$on('global-back', payload => {
            // console.log(payload);
            if (payload.in_view.toLowerCase() == 'airtime' && payload.action == "back") {
                if(this.view == 'otp'){
                    this.changePhoneAfterOtp();
                    // this.$emit('handleTitle', 'Verification Code');
                    this.$emit('handleTitle', 'Verification Code');
                }else{
                    this.changePaymentOption();
                }
            }
        });

        this.type = this.data.details.auth_type.toLowerCase()

        switch (this.type) {
            case 'airtime':
                this.msisdn = this.$userFriendlyMsisdn(this.$store.state.payload.transaction.customer.mobile_no)
                this.level1Change = 'Change Network';
                this.level2Change = 'Change Phone Number';

                break;
            case 'bank.account':
                this.level1Change = 'Change Bank';
                this.level2Change = 'Change Account Number';

                // this.msisdn = '';
                break;

            case 'wallet':
                this.level1Change = 'Change Wallet Provider';
                this.level2Change = 'Change Wallet ID';

                break;

            case 'voucher':
                this.view = 'voucher';
                this.level1Change = 'Change Provider';
                this.level2Change = 'Change Wallet ID';

                break;

            default:
                break;
        }

        if (this.data.details.action.length === 0) {
            this.options = null;
            return ;
        }else if (this.data.details.action.length === 1) {

            this.view = 'msisdn'
            this.options = this.data.details.action
            this.chunk_items = this.options.slice(0, 5);
            this.selectOption(0);
        } else if (this.data.details.action.length > 1) {

            this.view = 'listings'
            this.options = this.data.details.action
            this.headingMessage = this.data.details.message
            if (this.client_info.paginate_count && this.client_info.paginate_count > 0)
                this.chunk_items = this.options.slice(0, this.client_info.paginate_count > 0 ? this.client_info.paginate_count : 5);
            else
                this.chunk_items = this.options

            if (Object.keys(this.data.details).includes('provider_key')) // Handles default view
                this.selectOption([parseInt(this.data.details.provider_key)]);
        }

    },

    watch: {
        trx_otp(newVal) {
            if (this.errors.trx_otp) {
                this.errors.trx_otp = false;
                this.trx_otp = newVal;
            }
        },
        isFocus(newVal) {
            if (newVal)
                this.focusColor = this.appColor
        },
        loading(val) {
            if (!val) {
                this.$emit('hideBack', true)
            } else {
                this.$emit('hideBack', false)
            }

        },

        show_bank_list(val){
            if(val){
                if (window.$('#demoDefaultSelection2'))
                window.$('#demoDefaultSelection2').ddslick({
                    onSelected: (selectedData) => {
                        // defaultSelectedIndex: 0
                        this.bank_code = selectedData.selectedIndex || 0;
                        this.selectOption(this.bank_code);
                    }
                });
            }
        }

    },
    data() {
        return {
            // https://codepen.io/neil/pen/wLwVVB
            bank_index: 0,
            chunk_items: [],
            current_page: 0,
            isComingSoon: false,
            isOTP: true,
            trx_otp: '',
            account_name: '',
            otp_error_message: '',
            isFocus: true,
            view: '',
            focusColor: '',
            msisdn: '',
            options: [],
            current_option: {},
            voucher_pin: '',
            loading: false,
            countDownSeconds: 120,
            level1Change: '',
            level2Change: '',
            headingMessage: '',
            type: '',
            initialLegStatus: 'waitingforotp',
            errors: {
                trx_otp: false,
            },
            show_bank_list: false,
            banks: [],
            bank_code: '',
            voucherIsFocus: false,
            accountNumberIsFocus: false,
        }
    },
    methods: {
        selectBank(e) {
            console.log(e.target.value)
        },
        selectNibbsBank(e){
            console.log(e.target.value)
        },
        changePaymentOption() {
            this.$parent.changeComponent("PaymentOptions");
            clearInterval(window.countDown);

            this.type = ''
            this.current_option = '';
            delete this.data.details.provider_key
            this.view = 'listings'
            this.isOTP = true;
            this.show_bank_list = false;

            // Generates  new Transaction ref while changing payment options at these points,becuase the initial transaction ref is used.
            let criticalViews = ['otp', 'noinput-countdown'];
            if (criticalViews.indexOf(this.view)) {
                const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef(4)}`; 
                this.$store.dispatch('transRef', newRef);
                this.$store.dispatch('isFailed', true);
            }
        },
        handlePrev(val) {
            this.chunk_items = val.data;
            this.current_page = val.page;
        },

        handleNext(val) {
            this.chunk_items = val.data;
            this.current_page = val.page;
        },

        goBack() {
            this.isComingSoon = false;
            this.headingMessage = this.data.details.message
            this.current_option = ''
            this.view = 'listings'
            this.show_bank_list = false;
            this.isOTP = true;
        },

        showLoader() {
            this.loading = true;
        },

        hideLoader() {
            this.loading = false;
        },

        changeVoucherNetwork() {
            // console.log(this.data.details.message)
            this.headingMessage = this.data.details.message
            this.current_option = '';
            delete this.data.details.provider_key
            this.view = 'listings'
            this.isOTP = true;
            this.show_bank_list = false;
        },

        changePhoneAfterOtp() {
            this.headingMessage = this.data.details.message
            this.current_page = this.current_option.page;
            this.msisdn = '';
            this.view = 'msisdn'
            this.trx_otp = '';
            this.show_bank_list = false;
            this.isOTP = true;
            // Generat a new Transaction ref, because the initial one has been usd on OnePipe.
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef(4)}`; 
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
        },

        getInitialPayload() {
            let p = this.$store.state.payload
            delete p.hasTLSFallback
            delete p.referrer
            delete p.mode
            return p
        },

        selectOption(index) {
            const val = this.chunk_items[index]; // this.options[index];
            // console.log(val);
            // console.log(index);
            // if(this.type != "bank.account")
                // this.$emit('handleTitle', val.option)


            if (val) {
                this.current_option = val;
                this.current_option.page = this.current_page;
                if (val.provider && (val.provider !== null || val.provider !== "")) {
                    if (val.provider.toLowerCase() === "comingsoon") { // Show coming soon
                        this.isComingSoon = true;
                    } else { // Is Present
                        // this.headingMessage = this.current_option.instructions || (this.type == 'bank.account' ? 'Enter your account number' : 'Enter your msisdn');
                        this.headingMessage = val.instructions;
                        if (this.type === 'airtime') {
                            this.msisdn = this.$userFriendlyMsisdn(this.$store.state.payload.transaction.customer.mobile_no)
                        }

                        let extras = this.current_option.extras
                        if (Object.keys(extras).includes('show_bank_list') &&extras.show_bank_list !== null && extras.show_bank_list.toLowerCase() === "true") {
                            this.show_bank_list = true;
                            let sortedBanks = nibssBanks.sort(this.$sortCompare)
                            this.banks = sortedBanks;
                        }

                        this.view = 'msisdn'
                    }
                }
                /* else {console.log("Provider is empty")
                // look at the instructions
                } */
            }
            /* else {
                this.isComingSoon = true;
                // console.log("Senior Coming Soon")
            } */

        },

        resendOtp() {
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef(4)}`; 
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.getOtp();
        },

        timeoutCountdown() {
            window.countDown = setInterval(() => {
                this.countDownSeconds--
                if (this.countDownSeconds <= 0) {
                    clearInterval(window.countDown);
                    this.lookupPendingTransactionAfterCountDown();
                    return;
                }
            }, 1000);

        },

        lookupPendingTransactionAfterCountDown() {
            this.loading = true;

            // let initialPayload = this.getInitialPayload(),
            let payload = {
                request_ref: this.$generateRequestRef(),
                request_type: this.$store.state.payload.request_type,
                auth: {
                    secure: this.msisdn,
                    auth_provider: this.current_option.provider
                },
                transaction: {
                    transaction_ref: this.$store.state.transRef
                }
            };

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            payload.transaction.transaction_ref = this.$store.state.transRef

            let data2 = {
                    endpoint: 'validate',
                    api_key: this.$store.state.api_key,
                    payload,
                },
                data = this.$generateToken(data2);

            // console.log(JSON.stringify(data2));
            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: 'Bearer ' + this.$store.state.payload.api_key
                }).then(response => {

                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                    // console.log(res);
                    window.raw = JSON.stringify(res);

                    if (response.status === 200) {

                        this.loading = false;

                        if (status == "successful") {
                            this.loading = false;

                            // Check if user set close_popup for card to onSuccess
                            // let payload = this.$store.state.payload
                            if (this.type == 'wallet') {
                                this.$parent.changeComponent('Status', {
                                    transRef: this.$store.state.transRef,
                                    type: 'Successful',
                                    data: responseData.data,
                                    message: message
                                });
                            }

                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    // console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })

        },

        voucherPay() {
            this.errors.voucher = ''
            if (this.voucher_pin.length < 11) {
                this.errors.voucher = "Please supply a valid voucher pin.";
                this.$refs.voucherInput.focus();
                return;
            }

            this.loading = true;

            let initialPayload = this.getInitialPayload()
            let randomId = this.$generateRequestRef(),
                payload = initialPayload;

            payload.auth = {
                type: this.type,
                secure: this.voucher_pin,
                auth_provider: this.current_option.provider
            }

            payload.request_ref = randomId;

            if (payload.transaction.meta) {
                payload.transaction.meta.telco = this.current_option.provider
            } else
                payload.transaction.meta = {
                    telco: this.current_option.provider,
                }

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            payload.transaction.transaction_ref = this.$store.state.transRef

            let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload
                },
                data = this.$generateToken(data2);

            delete data2.payload.api_key
            // console.log(JSON.stringify(data))
            // console.log(JSON.stringify(data2))

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }).then(response => {
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message;
                    // responseData = res.data;
                    // console.log(res);
                    window.raw = JSON.stringify(res);

                    if (response.status === 200) {

                        if (status == "successful") {
                            this.loading = false;
                            this.$parent.changeComponent('Status', {
                                transRef: this.$store.state.transRef,
                                type: 'Successful',
                                data: res,
                                message: message
                            });
                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    // console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })
        },

        getOtp() {
            this.errors.msisdn = ''
            let secure = '';

            if (this.type == "airtime") {
                if (this.msisdn.length < 10) {
                    this.errors.msisdn = "Please supply a valid item.";
                    return;
                }

                secure = this.msisdn;
            }

            if (this.type == "bank.account") {
                if (this.msisdn.length < 10) {
                    this.errors.msisdn = "Please supply a valid account number.";
                    return;
                }

                if (Object.keys(this.current_option.extras).includes('bank_code')) {
                    secure = `${this.msisdn};${this.current_option.extras.bank_code}`;
                } else {
                    if (this.show_bank_list) {
                        secure = `${this.msisdn};${this.bank_code}`;
                    } else {
                        secure = this.msisdn;
                    }
                }

            }

            this.loading = true;

            let initialPayload = this.getInitialPayload()
            let randomId = this.$generateRequestRef(),
                payload = initialPayload;

            payload.auth = {
                type: this.type,
                secure: secure,
                auth_provider: this.current_option.provider
            }

            payload.request_ref = randomId;

            switch (this.type) {
                case 'voucher':
                default:
                    if (payload.transaction.meta) {
                        payload.transaction.meta.current_option = this.current_option.provider
                    } else
                        payload.transaction.meta = {
                            current_option: this.current_option.provider.toLowerCase(),
                        }
                    break;

                case 'airtime':
                    if (payload.transaction.meta) {
                        payload.transaction.meta.current_option = this.current_option.provider
                    } else {
                        payload.transaction.meta = {
                            current_option: this.current_option.provider,
                        }
                    }
                    break;
                case 'bank.account':

                    break;

                case 'wallet':
                    break;
            }

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            payload.transaction.transaction_ref = this.$store.state.transRef

            let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload
                },
                data = this.$generateToken(data2);

            delete data2.payload.api_key
            // console.log(JSON.stringify(data))
            // console.log(data2);
            // console.log(payload);
            // return;

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }).then(response => {
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                    // console.log(res);
                    window.raw = JSON.stringify(res);

                    if (response.status === 200) {

                        if (status == "successful") {
                            this.loading = false;

                            // Check if user set close_popup for card to onSuccess
                            let payload = this.$store.state.payload;
                            this.$parent.changeComponent('Status', {
                                reference: payload.transRef,
                                data: responseData,
                                type: 'Successful',
                                message: message || res.data.message
                            });

                        } else if (status == "waitingforotp" || status == "pendingvalidation" || status == "pendingfulfillment") {
                            this.loading = false;
                            if (this.type == "wallet" && responseData.provider_response.no_input) {
                                this.headingMessage = message
                                this.view = 'noinput-countdown'
                                this.countDownSeconds = responseData.provider_response.count_down_timeout;

                                // start countdown in 5 secs
                                setTimeout(() => {
                                    this.timeoutCountdown();
                                }, 2000);
                            } else {
                                this.view = 'otp'
                                this.headingMessage = message || `Enter otp sent to ${this.$maskPhone(this.msisdn)}`
                                if (status == "pendingvalidation") {
                                    this.isOTP = false;
                                    this.initialLegStatus = status
                                }
                            }

                            return;
                        } else {
                            // this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    // console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })
        },

        submitOtp() {
            if (this.trx_otp.length <= 3) {
                this.errors.trx_otp = true;
                this.otp_error_message = "Please supply OTP code.";
                return;
            }

            this.loading = true;

            let initialPayload = this.getInitialPayload(),
                payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: initialPayload.request_type,
                    auth: {
                        secure: this.trx_otp,
                        auth_provider: this.current_option.provider
                    },
                    transaction: {
                        transaction_ref: this.$store.state.transRef
                    }
                };

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            let data2 = {
                    endpoint: 'validate',
                    api_key: this.$store.state.api_key,
                    payload,
                },
                data = this.$generateToken(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: 'Bearer ' + this.$store.state.payload.api_key
                }).then(response => {

                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                    // console.log(res);
                    window.raw = JSON.stringify(res);

                    if (response.status === 200) {
                        if (status == "successful") {
                            this.loading = false;
                            // this.loadingMessage = "";
                            this.$parent.changeComponent('Status', {
                                transRef: this.$store.state.transRef,
                                type: 'Successful',
                                status: 'Successful',
                                data: responseData,
                                message: message
                            });

                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.message);
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })
        }
    }
};
</script>

<style scoped>

.hasMsisdn {
    padding-left: 92px;
}

.dd-option {
    text-decoration: none !important;
}

.dd-option .dd-option-selected {
    line-height: 25px !important;
    padding: 15px 10px !important;
}

</style>
